import { redirectToLogin } from 'utils/redirectTo'
import { ActionType } from 'redux-promise-middleware'
import { localize } from 'store/modules/localization'
import store from 'store/store'
import { actionCreators } from 'store/modules/dialogs'
import dialogTypes from 'dialogs/dialogTypes'
import 'polyfills/endsWith'

const showErrorAlert = (message) => {
  return store.dispatch(
    actionCreators.showDialog({
      dialogType: dialogTypes.alert,
      context: { message }
    })
  )
}

export const errorMiddleware = store => next => action => {
  if (action.type) {
    if (action.type.endsWith(ActionType.Rejected)) {
      const { payload } = action
      let errorAlertMessage = null
      if (payload) {
        if (payload.response) {
          switch (payload.response.status) {
            case 404:
              errorAlertMessage = localize(store.getState().localization, 'common.pageNotExist')
              break
            case 401:
              redirectToLogin()
              return next(action)
            default:
              if (payload.response.data) {
                const { error } = payload.response.data
                errorAlertMessage = (error ? `${error.message} ${error.details || ''}`.trim() : payload.response.data.message)
              } else {
                errorAlertMessage = payload.response.message
              }
              break
          }
        } else {
          errorAlertMessage = payload.message
        }
      }
      showErrorAlert(errorAlertMessage || localize(store.getState().localization, 'common.unknownError'))
    }
  }
  return next(action)
}
